// Stylesheet for the 2D map, injected once per document. Class prefix "uzm".
// Low specificity on purpose so the HUD can override placement/size.

const STYLE_ID = 'uzm-style';

const CSS = `
.uzm{position:relative;overflow:hidden;box-sizing:border-box;touch-action:none;user-select:none;-webkit-user-select:none;
  -webkit-tap-highlight-color:transparent;background:#e4e4e2;font-family:system-ui,-apple-system,"Segoe UI",Roboto,sans-serif;outline:none}
.uzm--hidden{display:none!important}
.uzm--mini{width:var(--uzm-mini-size,150px);height:var(--uzm-mini-size,150px);border-radius:var(--uzm-mini-radius,16px);
  border:2px solid rgba(255,255,255,.92);box-shadow:0 2px 10px rgba(0,0,0,.35);cursor:pointer}
.uzm--mini:focus-visible{border-color:#1a73e8}
.uzm--full{position:fixed;inset:0;width:auto;height:auto;z-index:var(--uzm-full-z,1000);border-radius:0;border:0}
.uzm-canvas{position:absolute;left:0;top:0;width:100%;height:100%;display:block;touch-action:none}
.uzm-attr{position:absolute;left:0;right:0;bottom:0;padding:2px 6px;font-size:10px;line-height:1.25;color:#333;
  background:rgba(255,255,255,.78);pointer-events:none;text-align:right}
.uzm--mini .uzm-attr{font-size:9px;line-height:1.3;padding:1px 4px;text-align:center;color:#444;background:rgba(255,255,255,.72);
  white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.uzm-controls{display:none}
.uzm--full .uzm-controls{display:block}
.uzm-btn{position:absolute;display:flex;align-items:center;justify-content:center;gap:6px;min-width:48px;height:48px;padding:0;
  border:0;border-radius:24px;background:rgba(255,255,255,.96);color:#1d1d1f;box-shadow:0 1px 6px rgba(0,0,0,.3);
  font:500 28px/1 system-ui,-apple-system,"Segoe UI",Roboto,sans-serif;touch-action:manipulation;cursor:pointer}
.uzm-btn:active{background:#e6e6e6}
.uzm-close{top:14px;right:14px}
.uzm-zin{right:14px;top:calc(50% - 54px)}
.uzm-zout{right:14px;top:calc(50% + 6px)}
.uzm-center{right:14px;bottom:44px;padding:0 16px 0 12px;font-size:15px;font-weight:600}
.uzm-center--active{color:#1a73e8}
`;

export function ensureMapStyles(): void {
  if (document.getElementById(STYLE_ID)) return;
  const el = document.createElement('style');
  el.id = STYLE_ID;
  el.textContent = CSS;
  // Prepend so that app styles loaded later win on equal specificity.
  document.head.prepend(el);
}
